import type { AppDispatch } from '../store/indexRedux';
import { fetchUserCompany } from '../store/companySlice';
import { getSessionFromCookie } from '../components/utils/cognito';

// Best-effort switch to a permalink's owning company. `selectedCompanyId` is written only
// after the thunk fulfils, so a failed switch never clears a working selection.
export const autoSelectCompany = (
  dispatch: AppDispatch,
  companyId: number,
  currentCompanyId: number | null | undefined,
): void => {
  if (companyId === currentCompanyId) return;
  const token = getSessionFromCookie()?.getAccessToken().getJwtToken();
  dispatch(fetchUserCompany({ company_id: companyId, token }))
    .unwrap()
    .then(() => localStorage.setItem('selectedCompanyId', String(companyId)))
    .catch(() => {
      /* non-member admin: getUserCompany 404s — keep the existing selection */
    });
};
